module.exports = __webpack_public_path__ + "static/media/market.ab7d40a2.jpg";